import { IEvents } from '../../types';
import { isActiveLesson } from './mapRenderers';

export const calculateTime = (
  lesson?: IEvents
): {
  duration: number;
  rotate: number;
} => {
  const timer = { duration: 0, rotate: 0 };

  if (!lesson) {
    return timer;
  }

  // default rotation
  timer.rotate = 360;

  const futureDate = new Date(lesson.endTime).getTime();
  const nowMS = new Date().getTime();

  const diff = futureDate - nowMS;

  timer.duration = diff;

  return timer;
};

export const isOfflineLessonsNow = (l: IEvents): boolean => {
  return isActiveLesson(l) && l.link == null;
};

export const getActiveOffEvent = (lessons: IEvents[]): IEvents | undefined => {
  return lessons.find((l) => isOfflineLessonsNow(l));
};
